<template>
  <div>
    <v-row>
      <v-col><h2>Статистика</h2></v-col>
      <v-col
        >c
        <datepicker-input
          :initialDate="initialDateFrom"
          class="inline-picker"
          @change="updateFrom"/>
        по
        <datepicker-input
          :initialDate="initialDateTo"
          @change="updateTo"
          class="inline-picker"
      /></v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :loading="loading"
      class="elevation-1 mb-60"
    >
      <template v-slot:item.date="{ item }">
        {{ new Date(item.date * 1000).toLocaleDateString() }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DatepickerInput from "../components/DatepickerInput";
import api from "../api";
import axios from "axios";
import moment from "moment";

export default {
  name: "statistic",
  props: ["id"],
  components: {
    DatepickerInput
  },
  data() {
    return {
      items: [],
      options: {},
      from: moment()
        .startOf("day")
        .format("X"),
      to: moment()
        .add(1, "day")
        .startOf("day")
        .format("X"),
      loading: false,
      headers: [
        {
          text: "Дата",
          value: "date"
        },
        {
          text: "Запросы к списку",
          value: "list"
        },
        {
          text: "Запросы к товарам",
          value: "goods"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getStatistics();
      }
    }
  },
  computed: {
    initialDateFrom() {
      return moment()
        .startOf("day")
        .format("YYYY-MM-DD");
    },
    initialDateTo() {
      return moment()
        .add(1, "days")
        .startOf("day")
        .format("YYYY-MM-DD");
    }
  },
  methods: {
    updateFrom(date) {
      this.from = new Date(date).getTime() / 1000;
      this.update();
    },
    updateTo(date) {
      this.to = new Date(date).getTime() / 1000;
      this.update();
    },
    update() {
      if (this.from && this.to && this.from < this.to) {
        this.getStatistics();
      }
    },
    getStatistics() {
      this.loading = true;
      axios
        .get(api.statistic(this.id), {
          params: {
            "per-page":
              this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 1000,
            page: this.options.page,
            from: this.from || new Date(this.initialDateFrom).getTime() / 1000,
            to: this.to || new Date(this.initialDateTo).getTime() / 1000
          }
        })
        .then(resp => {
          this.items = resp.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.inline-picker {
  display: inline-block;
}
</style>
